import GeniusSection from './GeniusSection';
export default GeniusSection;
